// VisemeContext.js
import { createContext, useContext } from "react";

/** Changing viseme visualizations: pairs, totals, combo grid. */
export const VisemeDataCtx = createContext(null);

/** Stable viseme commands + current-viseme ref. Identity does not change on Idylate.
 *  Includes getTotalPairsEver() so persistence can read the monotonic counter
 *  without subscribing the studio root to VisemeDataCtx. */
export const VisemeActionsCtx = createContext(null);

/** Current viseme index (0–32). Only subscribers of this context rerender on Idylate. */
export const CurrentVisemeCtx = createContext(0);

export const VisemeCtx = VisemeDataCtx;

export const useVisemes = () => {
  const data = useContext(VisemeDataCtx);
  const actions = useContext(VisemeActionsCtx);
  if (!data || !actions) throw new Error("useVisemes must be used within a VisemeProvider");
  return { ...data, ...actions };
};

export const useVisemeActions = () => {
  const ctx = useContext(VisemeActionsCtx);
  if (!ctx) throw new Error("useVisemeActions must be used within a VisemeProvider");
  return ctx;
};

export const useCurrentViseme = () => useContext(CurrentVisemeCtx);
